import { useTranslation } from 'react-i18next';
import TrackedRedirectButton from '@/components/TrackedRedirectButton/TrackedRedirectButton';
import { BUTTON_SOURCES } from '@/constants/buttonSources';
import useValidateQueryParams from '@/hooks/useValidateQueryParams';
import styles from '@/screens/Entry/Entry.module.scss';
import { useLink } from './useLink';

interface LinkToMenuProps {
  isLoading?: boolean;
}

export const LinkToMenu = ({ isLoading }: LinkToMenuProps) => {
  const { t } = useTranslation();
  const { link, isLoading: isLoadingLink } = useLink();
  const buttonId = 'view-menu';
  const buttonName = t('menu.entry.viewMenu');
  const { queryParams } = useValidateQueryParams();
  const { brandId, tableNumber, counterNumber } = queryParams();

  return (
    <TrackedRedirectButton
      buttonId={buttonId}
      buttonName={buttonName}
      buttonSource={BUTTON_SOURCES.WELCOME_SCREEN}
      className={styles.white}
      data-testid={buttonId}
      url={link}
      urlParams={{
        brandId: brandId || undefined,
        orderId: undefined,
        tableNumber: tableNumber,
        counterNumber: counterNumber,
      }}
      isLoading={isLoadingLink || isLoading}
    >
      {buttonName}
    </TrackedRedirectButton>
  );
};
